import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { BaseModule } from './@core/modules/base.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSelectModule,
  NbStepperModule,
  NbIconModule
} from '@nebular/theme';


import { NbEvaIconsModule } from '@nebular/eva-icons';

import {
  NgxUiLoaderModule,
  NgxUiLoaderHttpModule,
  NgxUiLoaderConfig,
  POSITION,
  SPINNER,
  PB_DIRECTION,
} from 'ngx-ui-loader';

// Core Modules
// import { ToastrModule } from 'ngx-toastr';
// import { NgxPermissionsModule } from 'ngx-permissions';
import { ErrorHandlerModule } from './@core/modules/error-handler/error-handler.module';
import { FormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedTranslateModule } from './@core/modules/translate.module';
import { StarRatingModule } from 'angular-rating-star';
import { MatInputModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// in sub modules inject { TranslateModule } from '@ngx-translate/core';
// import { AngularMaterialModule }
// from './@core/modules/angular-materia/angular-material.module';
// import { MaterialTreeChecklistComponent }
// from './@core/modules/angular-materia/components/material-tree-checklist/material-tree-checklist.component';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  fgsColor: '#4581bf',
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 40,
  bgsType: SPINNER.ballScaleMultiple, // background spinner type
  fgsType: SPINNER.ballSpinFadeRotating, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
};
@NgModule({
  declarations: [AppComponent],
  imports: [
    BaseModule,
    AppRoutingModule,
    RouterModule,
    ThemeModule.forRoot(),
    MatInputModule,
    NbEvaIconsModule,
    BrowserAnimationsModule,
    NbIconModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbSelectModule,
    NbStepperModule,
    // NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    // NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),


    // Core Modules
    // ToastrModule.forRoot(),
    // NgxPermissionsModule.forRoot(),
    ErrorHandlerModule,
    RichTextEditorAllModule,
    NbDatepickerModule.forRoot(),
    FormsModule,
    NgxPermissionsModule.forRoot(),
    SharedTranslateModule,
    StarRatingModule,

    // AngularMaterialModule,
  ],
  exports: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
